"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CloudTourism = void 0;
const Card_1 = require("../Card");
const CardName_1 = require("../../CardName");
const CardType_1 = require("../CardType");
const CardRenderer_1 = require("../render/CardRenderer");
const Tags_1 = require("../Tags");
const ResourceType_1 = require("../../ResourceType");
const CardRenderDynamicVictoryPoints_1 = require("../render/CardRenderDynamicVictoryPoints");
const Resources_1 = require("../../Resources");
class CloudTourism extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.ACTIVE,
            name: CardName_1.CardName.CLOUD_TOURISM,
            tags: [Tags_1.Tags.JOVIAN, Tags_1.Tags.VENUS],
            cost: 11,
            resourceType: ResourceType_1.ResourceType.FLOATER,
            metadata: {
                cardNumber: 'P69',
                description: 'Increase your M€ production 1 step per set of Earth and Venus tags you have.',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.action('Add 1 floater to this card.', (eb) => {
                        eb.empty().startAction.floaters(1);
                    });
                    b.br;
                    b.vpText('1 VP for every 3 floaters on this card.');
                    b.br;
                    b.production((pb) => {
                        pb.megacredits(1).slash().earth().played.venus(1).played;
                    });
                }),
                victoryPoints: CardRenderDynamicVictoryPoints_1.CardRenderDynamicVictoryPoints.floaters(1, 3),
            },
        });
        this.resourceCount = 0;
    }
    play(player) {
        const earthTagsInPlay = player.getTagCount(Tags_1.Tags.EARTH);
        const venusTagsInPlay = player.getTagCount(Tags_1.Tags.VENUS) + 1;
        player.addProduction(Resources_1.Resources.MEGACREDITS, Math.min(earthTagsInPlay, venusTagsInPlay), { log: true });
        return undefined;
    }
    canAct() {
        return true;
    }
    action(player) {
        player.addResourceTo(this, { log: true });
        return undefined;
    }
    getVictoryPoints() {
        return Math.floor(this.resourceCount / 3);
    }
}
exports.CloudTourism = CloudTourism;
//# sourceMappingURL=CloudTourism.js.map